<app-modal
  [isActive]="open$ | async"
  [isSmall]="true"
  [showCloseFooter]="false"
  (modalState)="openModal(false)"
>
  <p class="modal-card-title" modal-title>
    {{ 'change-password.title' | translate }}
  </p>

  <form [formGroup]="form" (ngSubmit)="submit()" modal-content>
    <p class="has-text-grey mb-2">
      {{ 'change-password.subtitle' | translate }}
    </p>

    <div class="columns">
      <div class="column">
        <app-input-field
          [form]="form"
          type="password"
          inputName="old"
          [label]="'change-password.old-password' | translate"
          [placeholder]="'change-password.old-password' | translate"
          [errorMessage]="'errors.required-field' | translate"
        ></app-input-field>
      </div>
    </div>
    <br />

    <div class="columns">
      <div class="column">
        <app-input-field
          [form]="form"
          [error]="
            form?.controls?.new?.touched && form?.controls?.new?.errors?.pattern
          "
          type="password"
          inputName="new"
          [label]="'change-password.new-password' | translate"
          [placeholder]="'change-password.new-password' | translate"
          [errorMessage]="'change-password.not-strong' | translate"
        ></app-input-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <app-input-field
          [error]="
            form?.controls?.confirm?.touched && form?.errors?.differentPassword
          "
          [form]="form"
          type="password"
          inputName="confirm"
          [label]="'change-password.confirm-password' | translate"
          [placeholder]="'change-password.confirm-password' | translate"
          [errorMessage]="'change-password.error' | translate"
        ></app-input-field>
      </div>
    </div>
  </form>

  <div class="columns" modal-footer>
    <div class="column is-3 is-offset-9">
      <app-input-submit
        inputText="{{ 'shared.save' | translate }}"
        type="submit"
        (clickButton)="submit()"
        [disabled]="!form.valid"
      ></app-input-submit>
    </div>
  </div>
</app-modal>
